/**
 * @http 配置url
 * **/
const urls = {
  tigrisso_home_list: '/client/get/index/list/', // 首页 pcMobile
  tigrisso_tv_list: '/client/tigrisso/tv/list', // tsTV列表
  tigrisso_tv_detail: '/client/tigrisso/tv/detail/', // tsTV详情
  tigrisso_world_list: '/client/tigrisso/world/list', // tsWorld列表
  tigrisso_world_detail: '/client/tigrisso/world/detail/', // tsWorld详情
  tigrisso_main_push_detail: '/client/recommend/series/detail/', // 主推系列详情
  tigrisso_mult_shock_detail: '/client/multivariant/shock/detail/', // 查询多元碰撞详情
  tigrisso_mult_shock_list: '/client/multivariant/shock/list/', // 多元碰撞列表
  tigrisso_theme_detail: '/client/recommend/theme/detail/', // 获取主题详情
  tigrisso_theme_list: '/client/recommend/theme/list/', // 获取主题系列列表
  tigrisso_query_product_detail: '/client/item/brower/detail/', // 查询商品详情
  tigrisso_column_list: '/client/product/column/', // 查询商品栏目列表
  tigrisso_query_product: '/client/get/product/condition/list', // 商品查询
  tigrisso_category_condiction: '/client/get/product/category/', // 查询栏目筛选条件
  tigrisso_product_detail: '/client/item/brower/detail/', // 商品详情
  tigrisso_query_province: '/client/get/shop/provinces', // 查询省份
  tigrisso_shop_list: '/client/get/shop/province/detail', // 查询当前省份的所有店铺店铺
  tigrisso_shop_nearestShop: '/client/get/shop/nearestShop/' // 查询附近店铺{}/{}/{}
}

export default urls



// WEBPACK FOOTER //
// ./src/api/config.js